
const handleUserRole = ( role ) => {
    switch ( role ) {
      case "MASTER":
        return "MASTER"
      case "MANAGER":
        return "Gerente"
      case "APP_USER":
        return "Usuário de App"
      case "PANEL_USER":
        return "Usuário de Painel"
      default:
        return ""
    }
};

export {handleUserRole}